import { render, staticRenderFns } from "./ReferralProgramDetails.vue?vue&type=template&id=5538df0a&"
import script from "./ReferralProgramDetails.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports